import { useState } from 'react';
import ReactTable from './ReactTable';

import './style.scss';

const Table = (props) => {

    const {
        tblCode,
        columns,
        data,
        rowClass,
        element,
        customSelectedBox,
        hideTableHeader,
        hideTableFooter,
        enableSelectRow,
        disableSelectionPageSize,
        disablePaging = false,
        disableField,
        disableFieldValue = null,
        enableServerSidePaging = false,
        initialTableState,
        className,
        enableStickyHeader = false,
        tableFooter,
        onSelectedChange,
        disabledNoData = false,
        isSelectedAll = null,
        selectedRowIds = {},
        disableSubRowSelect = false,
        lstDisabledRowSelect = [],
        showDisabledRowSelect = true,
        checkedDisabledRowSelect = false,
        useCustomSelectedAll = false,
        isSelectedAllCustom = false,
        onSelectedAllChange = () => { },
        onFetch,
        rowKey,
        getRowId,
        showPagingInfo = true,
        scrollHorizontalWidth = false,
        freezeColumn = false,
        isMultiSort = false,
        enableDragScroll = false
    } = props;

    const [pageIndex, setPageIndex] = useState(0);

    const tranformTableStateToServerState = (tableState) => {
        const sortBy = tableState.sortBy || [];
        let sortKeys = null;
        let sortDirs = null;

        if (isMultiSort) {
            // Logic for multiple columns: join into a string
            sortKeys = sortBy.map(item => item.id).join(',');
            sortDirs = sortBy.map(item => item.desc ? 'DESC' : 'ASC').join(',');
        } else {
            // Old logic: only take the first column
            if (sortBy.length > 0) {
                sortKeys = sortBy[0].id;
                sortDirs = sortBy[0].desc ? 'DESC' : 'ASC';
            }
        }

        const newState = {
            page: tableState.pageIndex + 1,
            size: tableState.pageSize,
            sortKey: sortKeys,
            sortDir: sortDirs
        };
        onFetch(newState);
    };

    const tranformServerStateToTableState = (initialTableState) => {
        if (!initialTableState) return null;

        let sortBy = [];

        if (initialTableState.sortKey) {
            // Split the string from the server
            const keys = initialTableState.sortKey.split(',').map(k => k.trim());
            const dirs = initialTableState.sortDir
                ? initialTableState.sortDir.split(',').map(d => d.trim())
                : [];

            // Map into objects
            const fullSortBy = keys.map((key, index) => {
                const dir = dirs[index];
                return {
                    id: key,
                    desc: dir === 'DESC'
                };
            });

            if (isMultiSort) {
                sortBy = fullSortBy;
            } else {
                if (fullSortBy.length > 0) {
                    sortBy = [fullSortBy[0]];
                }
            }
        }

        return {
            pageIndex: initialTableState.page - 1,
            totalPage: initialTableState.totalPage,
            totalRecord: initialTableState.totalRecord,
            pageSize: initialTableState.size,
            sortBy: sortBy
        };
    };

    return (
        <ReactTable
            tblCode={tblCode}
            element={element}
            customSelectedBox={customSelectedBox}
            columns={columns}
            data={data}
            hideTableHeader={hideTableHeader}
            hideTableFooter={hideTableFooter}
            enableSelectRow={enableSelectRow}
            disableSelectionPageSize={disableSelectionPageSize}
            disableFieldValue={disableFieldValue}
            disableField={disableField}
            disablePaging={disablePaging}
            pageIndexProp={pageIndex}
            rowClass={rowClass}
            changePageIndexProp={(pageIndex) => {
                setPageIndex({ pageIndex });
            }}
            enableServerSidePaging={enableServerSidePaging}
            onFetch={tranformTableStateToServerState}
            initialTableState={tranformServerStateToTableState(
                initialTableState
            )}
            className={className}
            tableFooter={tableFooter}
            onSelectedChange={onSelectedChange}
            disabledNoData={disabledNoData}
            isSelectedAll={isSelectedAll}
            selectedRowIds={selectedRowIds}
            disableSubRowSelect={disableSubRowSelect}
            showDisabledRowSelect={showDisabledRowSelect}
            lstDisabledRowSelect={lstDisabledRowSelect}
            checkedDisabledRowSelect={checkedDisabledRowSelect}
            useCustomSelectedAll={useCustomSelectedAll}
            isSelectedAllCustom={isSelectedAllCustom}
            onSelectedAllChange={onSelectedAllChange}
            rowKey={rowKey}
            getRowId={getRowId}
            showPagingInfo={showPagingInfo}
            scrollHorizontalWidth={scrollHorizontalWidth}
            freezeColumn={freezeColumn}


            disableMultiSort={!isMultiSort}


            isMultiSortEvent={isMultiSort ? () => true : undefined}
            enableDragScroll={enableDragScroll}
            enableStickyHeader={enableStickyHeader}


        />
    )
}

export default Table;